import { FieldType } from '90.quickConnect.Models/enums';
import { FieldDesc } from '90.quickConnect.Models/models';

export const isAFieldContainer = ({ fieldType }: FieldDesc): boolean =>
  fieldType === FieldType.Action ||
  fieldType === FieldType.Dialog ||
  fieldType === FieldType.Group ||
  fieldType === FieldType.Include ||
  fieldType === FieldType.ImagesGroup ||
  fieldType === FieldType.RepeatableGroup ||
  fieldType === FieldType.Step;

/**
 * Determines if a container field should be excluded from summary display.
 * Excludes Group, Dialog, RepeatableGroup, ImagesGroup, and TodoList containers.
 * Include fields are transparent - their children will be displayed instead.
 */
export const shouldExcludeFromSummaryDisplay = (input: any): boolean =>
  'fieldType' in input &&
  (input.fieldType === FieldType.Group ||
    input.fieldType === FieldType.RepeatableGroup ||
    input.fieldType === FieldType.Dialog ||
    input.fieldType === FieldType.ImagesGroup ||
    input.fieldType === FieldType.TodoList);
